<template>
	<v-container>
		<safe_zone_events></safe_zone_events>
	</v-container>
</template>
<script>
import safe_zone_events from '@/components/gun/safe_zone_events.vue'
	export default{
		name: 'gun',
		components: { safe_zone_events }, 
		data: () => ({
			option: '',
		}), // data
		created(){
			// console.log(this.$route, 'routes')
			// if (this.$route.params) {

			// //let route=this.$route.params.opt;
			// }
		}
	};
</script>